import gql from 'graphql-tag';

export const CREATE_ESSENTIAL_ACCOUNT_INVITATION_QUERY = gql`
  query createEssentialAccountInvitationQuery($partnerId: ID!) {
    activeLocales
    availableNumbersOfEmployees(id: $partnerId)
    account(id: $partnerId) {
      id
      displayName
      type
      assessmentTemplates(first: 100) {
        edges {
          node {
            id
            title
          }
        }
      }
      assessmentSections {
        behaviorSection {
          displayName
          dimensions {
            id
            name
            displayName
          }
          distortionDimensions {
            id
            name
            displayName
          }
        }
        cognitiveSection {
          displayName
          dimensions {
            id
            name
            displayName
          }
        }
        interestsSection {
          displayName
          dimensions {
            id
            name
            displayName
          }
        }
      }
      surveyTemplates(first: 100) {
        edges {
          node {
            id
            title
          }
        }
      }
      surveyCompetencies {
        id
        displayName
        abilities {
          id
          displayName
        }
      }
    }
  }
`;

export const CREATE_ESSENTIAL_ACCOUNT_INVITATION_MUTATION = gql`
  mutation createEssentialAccountInvitationMutation($input: CreateEssentialAccountInvitationInput!) {
    createEssentialAccountInvitation(input: $input) {
      clientInvitation {
        id
      }
    }
  }
`;
